import { languageMap } from ".."

languageMap.properties = {
	comments: {
		line: "#",
	},
}
